import {AnalyticsContract, AnalyticsProvider} from "../../contracts/analytics/analytics";
import Event from "../../core/consts/analytics-events";
const CompositeAnalyticsProvider = (implementations:AnalyticsContract[]) : AnalyticsContract =>({
  setup() {
    implementations.forEach(p=>{
      p.setup();
    });
  },
  reset() {
    implementations.forEach(p=>{
      p.reset();
    });
  },
  track(event: Event, context: any) {
    implementations.forEach(p=>{
      p.track(event,context);
    });
  },
  identify(identifier: any) {
    implementations.forEach(p=>{
      p.identify(identifier);
    });
  }
  });

export default CompositeAnalyticsProvider;
